import React from 'react';

const NpsScale = ({ value, onChange }) => (
  <div>
    <div className="ef-nps" role="radiogroup" aria-label="Net Promoter Score">
      {Array.from({ length: 10 }, (_, i) => i + 1).map((score) => (
        <button
          key={score}
          type="button"
          className={['ef-nps__btn', value === score ? 'ef-nps__btn--selected' : '']
            .filter(Boolean)
            .join(' ')}
          onClick={() => onChange(score)}
          aria-label={`Score ${score}`}
          aria-checked={value === score}
          role="radio"
        >
          {score}
        </button>
      ))}
    </div>
    <div className="ef-scale-labels" style={{ marginTop: 10 }}>
      <span>Not at all likely</span>
      <span>Extremely likely</span>
    </div>
  </div>
);

export default NpsScale;
